import { createFileRoute } from "@tanstack/react-router";
import { CityRedirect } from "@/components/layout/CityRedirect";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/city/$citySlug/")({
  head: ({ params }) => routeHead("/uk/city/$citySlug/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CityRedirect />
  );
}
